<template>
    <div class="wrapper">
        <div v-if="loadingReport" class="loading">
            <Loader />
        </div>
		<section v-else-if="report === null">
			<p>No Psychometric Report found</p>
		</section>
		<section v-else>
			<h5 class="text-center bold">Psychometric Test Report</h5>
			<div class="report" id="report" v-html="report.report"></div>         
            <button
                class="btn btn--md btn__primary"
                @click.prevent="printReport"
                type="button"
                name="button">Print
            </button>
        </section>
    </div>
</template>

<script>
import * as JsPdf from 'jspdf';
import domToImage from 'dom-to-image';
import Loader from './Loader';
import { getUserTestOutcome } from '../utils/api/quiz';

export default {
	name: 'Reports',
	data() {
		return {
			loading: true,
			outcomes: [],
			responses: [],
			report: {},
			loadingReport: true,
			reportLoaded: false,
			reportUrl: ''
		};
	},
	created() {
		this.getUserReport();
	},
	methods: {
		getUserReport() {
			getUserTestOutcome(this.$session.get('id'))
				.then((response) => {
					if (response.status === 200) {
						this.report = response.data.data;
						this.reportLoaded = true;
						return true;
					}
					this.reportLoaded = false;
					return false;
				})
				.catch((error) => {
					this.reportLoaded = false;
					return error;
				})
				.finally(() => {
					this.loadingReport = false;
				});
			return true;
		},
		printReport() {
			domToImage.toPng(document.getElementById('report'), { quality: 0.95 })
				.then((dataUrl) => {
					this.reportUrl = dataUrl;
					const doc = new JsPdf('p', 'pt', 'a4');
					doc.addImage(dataUrl, 'PNG', 30, 30, 500, 350);
					doc.save('report.pdf');
				})
				.catch((error) => {
					return error;
				});
			return true;
		}
	},
	components: {
		Loader
	}
};
</script>

<style lang="scss" scoped>
	.loading {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100vh;
	}
	button {
		margin-top: 30px;
	}
	.wrapper {
		margin: 30px;
		width: 100%;
	}
	.report {
		min-height: 60vh;
		font-weight: normal;
		text-align: left;
	}
	.text-center {
		margin-bottom: 25px;
	}
</style>